import type { CourseProgress, ProgressPayload } from '@/redis/progressStore';

export async function updateCourseProgress(progress: ProgressPayload) {
  const result = await fetch(`${process.env.NEXT_PUBLIC_NEXTAUTH_URL}/api/course-progress`, {
    method: 'PATCH',
    body: JSON.stringify(progress),
  });
  if (!result.ok) {
    return null;
  }
  const data: CourseProgress = await result.json();
  return data;
}

export async function fetchCourseProgress({
  courseId,
  userId,
}: {
  courseId: string;
  userId: string;
}) {
  const result = await fetch(
    `${process.env.NEXT_PUBLIC_NEXTAUTH_URL}/api/course-progress?courseId=${courseId}&userId=${userId}`,
  );
  if (!result.ok) {
    return null;
  }
  const data: CourseProgress = await result.json();
  return data;
}
